// extracted by mini-css-extract-plugin
module.exports = {"name":"NameCmp_name__3eazm","gold":"NameCmp_gold__orPZM","nameItem":"NameCmp_nameItem__3H5-v"};